import axios from 'axios';
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
export const errorMessage = (e) => {
  const detail = e.response?.data?.detail;
  return typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(x => `${x.loc.at(-1)}: ${x.msg}`).join('. ') : 'Unable to connect. Please try again.';
};
export const currency = (n, locale = 'en-IN') => new Intl.NumberFormat(locale, {style:'currency', currency:'INR', minimumFractionDigits:Number.isInteger(Number(n))?0:2, maximumFractionDigits:2}).format(n);
export const date = (value) => value ? new Date(value).toLocaleDateString(undefined, {day:'numeric', month:'short', year:'numeric'}) : '—';
export async function downloadDocument(document) {
  const {data} = await api.get(`/documents/${document.id}/download`, {responseType:'blob'});
  const url = URL.createObjectURL(data);
  const a = window.document.createElement('a'); a.href=url; a.download=`${document.title}.pdf`; a.click();
  setTimeout(()=>URL.revokeObjectURL(url), 15000);
}